export class ReceiptInfo {

  subtotal: number
  tax: number
  date: string
  purchaser: string

  constructor(data: any = {}) {
    this.subtotal = data.subtotal || 0
    this.tax = data.tax || 0
    this.date = data.date || new Date().toISOString().slice(0, 10)
    this.purchaser = data.purchaser || null
  }

  get total(): number {
    return this.subtotal + this.tax
  }

  get tax_rate(): number {
    if (this.subtotal > 0) { return Math.round(this.tax / this.subtotal * 10000) / 10000; }
    return 0
  }

}



// WEBPACK FOOTER //
// ./src/app/models/text-receipt/receipt-info.ts